<template>
  <span class="block text-sm text-error w-full">
    <slot></slot>
  </span>
</template>
